import { NavLink } from 'react-router';
import styled from 'styled-components';

import { TextCSS } from 'components/core/typography/Text';

import { BLUE_500, LETTER_SPACING_DEFAULT } from 'styles/tokens';

export const WrapLink = styled(NavLink)`
  cursor: pointer;
  display: block;
  text-decoration: none;

  &:focus {
    outline: none;
  }
`;

export const TextNavLink = styled(NavLink)`
  ${TextCSS}
  color: ${BLUE_500};
  letter-spacing: ${LETTER_SPACING_DEFAULT};
  text-transform: none;
`;
